import Vue from 'vue';
import Router from 'vue-router';
// import axios from 'axios';
//import cookie from 'js-cookie'
import store from '@/store/index';
//import Auth from '@/utils/auth'

Vue.use(Router);

const router =  new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import(/* webpackChunkName: "./views/Main.vue" */ './views/Main'),
      redirect: { name: 'Lots' },
      meta: { requiresAuth: true }
    },
    {
      path: '/profile',
      name: 'Profile',
      component: () => import(/* webpackChunkName: './views/Profile/index.vue' */ './views/Profile'),
      meta: { requiresAuth: true }
    },
    {
      path: '/lots',
      name: 'Lots',
      component: () => import(/* webpackChunkName: './views/Lots/LotsPage.vue' */ './views/Lots/LotsPage.vue'),
      meta: { requiresAuth: true },
      children: [
        {
          path: '/lots/create',
          name: 'LotsCreate',
          component: () => import(/* webpackChunkName: './components/Lots/NewLotForm.vue' */ './components/Lots/LotForm.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: ':id',
          name: 'LotsDetail',
          component: () => import(/* webpackChunkName: './components/Lots/LotForm.vue' */ './components/Lots/LotForm.vue'),
          meta: { requiresAuth: true }
        }
      ]
    },
    {
      path: '/admin',
      name: 'Admin',
      component: () => import(/* webpackChunkName: './views/Admin/index.vue' */ './views/Admin'),
      meta: { requiresAuth: true },
      beforeEnter(to, from, next) {
        if (store.state.user.userInfo) {
          if (store.state.user.userInfo && store.state.user.userInfo.roles && store.state.user.userInfo.roles.map(item => item.code).includes('ADMIN')) {
            next();
          } else {
            next(from.fullPath);
          }
        }
      },
      children: [
        {
          path: 'users',
          name: 'Users',
          component: () => import(/* webpackChunkName: './views/Admin/Users/index.vue' */ './views/Admin/Users'),
          meta: { requiresAuth: true },
          children: [
            {
              path: 'listusers',
              name: 'UsersList',
              component: () => import(/* webpackChunkName: './components/Users/List.vue' */ './components/Users/List'),
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: 'contacttk',
          name: 'ContactTk',
          component: () => import(/* webpackChunkName: './views/Admin/ContactTk/index.vue' */ './views/Admin/ContactTk'),
          meta: { requiresAuth: true },
          children: [
            {
              path: 'listcontacttk',
              name: 'ContactTkList',
              component: () => import(/* webpackChunkName: './components/ContactTk/List.vue' */ './components/ContactTk/List'),
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: 'carriercompany',
          name: 'CarrierCompany',
          component: () => import(/* webpackChunkName: './views/Admin/CarrierCompany/index.vue' */ './views/Admin/CarrierCompany'),
          meta: { requiresAuth: true },
          children: [
            {
              path: 'carriercompanylist',
              name: 'CarrierCompanyList',
              component: () => import(/* webpackChunkName: './components/CarrierCompany/List.vue' */ './components/CarrierCompany/List'),
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: 'references',
          name: 'References',
          component: () => import(/* webpackChunkName: './views/Admin/References/index.vue' */ './views/Admin/References'),
          meta: { requiresAuth: true },
          children: [
            {
              path: 'list',
              name: 'ReferenceList',
              component: () => import(/* webpackChunkName: './components/References/List.vue' */ './components/References/List'),
              meta: { requiresAuth: true }
            },
            {
              path: ':id',
              name: 'ReferenceDetail',
              component: () => import(/* webpackChunkName: './components/References/Detail.vue' */ './components/References/Detail'),
              meta: { requiresAuth: true }
            }
          ]
        }

      ]
    },
    {
      path: '/404',
      name: '404',
      component: () =>
        import(/* webpackChunkName: "pages/404" */ './views/Errors/404')
    }, {
      path: '*',
      redirect: '/404'
    },
    {
      path: '/403',
      name: '403',
      component: () =>
        import(/* webpackChunkName: "pages/403" */ './views/Errors/403')
    }
  ]
});

router.beforeEach((to, from, next) => {
  const isLogged = store.state.user.isLogged;

  if (to.matched.some(val => val.meta.requiresAuth)) {
    /**
     * Если нет одного из токенов, то очищаем старые данные
     * и вызываем метод relogin()
     * P.S. Куки на валидность проверяет Keycloak,
     * поэтому мы не беспокоимся об этом
    if (!(token.access && token.refresh)) {
      store.commit('unsetUser');
      Auth.relogin();
      return
    }
     */

    /**
     * Если у пользователя есть куки, но он не залогинен,
     * то запрашиваем данные по нему и передаем объект данных
     * из куки, чтобы зарегистрировать его в случае, если его
     * нет в системе
     */
    if (!isLogged) {
      store.dispatch('getInfo');
    }
  }

  next();
});

export default router;
